import PropTypes from "prop-types";
import { normalizeWebsiteHref } from "@/lib/format";

/**
 * Renders a website URL as a clickable external link, or plain fallback text.
 */
export function WebsiteLink({
  value,
  className = "",
  fallback = "—",
  id,
  style,
  "data-testid": dataTestId,
}) {
  const raw = value == null || value === "" ? "" : String(value).trim();
  if (!raw || raw === fallback) {
    return (
      <span id={id} className={className} style={style} data-testid={dataTestId}>
        {fallback}
      </span>
    );
  }

  const href = normalizeWebsiteHref(raw);
  if (!href) {
    return (
      <span id={id} className={className} style={style} data-testid={dataTestId}>
        {raw}
      </span>
    );
  }

  return (
    <a
      id={id}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      data-testid={dataTestId}
    >
      {raw}
    </a>
  );
}

WebsiteLink.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  fallback: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
  "data-testid": PropTypes.string,
};
